var document = require('./_global').document;
module.exports = document && document.documentElement;



// WEBPACK FOOTER //
// ./~/core-js/modules/_html.js